const { NEXT_PUBLIC_SCVR_ROOT } = process.env;
const { NEXT_PUBLIC_AUTH_ROOT } = process.env;

export const buildUrl = (url, auth) => {
  if (auth) {
    return `${NEXT_PUBLIC_AUTH_ROOT}/${auth}`;
  }
  return `${NEXT_PUBLIC_SCVR_ROOT}/${url}`;
};
